
// this file is automatically generated by git.version.ts script
export const versions = {
  version: '1.8.0',
  revision: '88f1d653',
  branch: 'develop',
  lastCommitTime: 'Mon Apr 19 19:10:00 2021 +0530'
};
